import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import SearchField from '../../../../components/DriveItemList/Search/Field';

const mapStateToProps = (state: StoreState) => {
	const { search } = state;
	return { search };
};

export default connect(mapStateToProps)(SearchField);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Field/index.tsx